import React from "react";
import { useTranslation } from "react-i18next";
import {
  useAssignCostProfileToResource,
  useRemoveCostProfileFromResource,
} from "@planzone/view-models";

import { Loader } from "@common/loader";
import { AllocationUnit } from "@common/allocationUnit";
import { Props } from "./types";
import { Icon } from "./icon";
import styles from "./styles.scss";

function CostProfile({ costProfile, resource }: Props) {
  const { t } = useTranslation();
  const {
    isRequestPending: isAssignRequestPending,
    assignCostProfileToResource,
  } = useAssignCostProfileToResource(costProfile, resource);
  const {
    isRequestPending: isRemoveRequestPending,
    removeCostProfileFromResource,
  } = useRemoveCostProfileFromResource(resource);
  const hasCost = typeof costProfile.cost !== "undefined";
  const isSelected =
    resource.costProfile && costProfile.uuid === resource.costProfile.uuid;
  const isRequestPending = isSelected
    ? isRemoveRequestPending
    : isAssignRequestPending;
  const act = () =>
    isSelected
      ? removeCostProfileFromResource(resource)
      : assignCostProfileToResource({ costProfile, resource });

  return (
    <div
      className={styles.costProfile}
      onClick={() => !isRequestPending && act()}
    >
      <div className={styles.row}>
        {isRequestPending ? (
          <div className={styles.icon}>
            <Loader />
          </div>
        ) : (
          <Icon className={styles.icon} />
        )}
        <h4 className={styles.name}>
          {costProfile.name}
          {hasCost ? ":" : ""}
        </h4>
      </div>
      {typeof costProfile.cost !== "undefined" && (
        <p className={styles.cost}>
          {costProfile.cost} € / <AllocationUnit format="text" />
        </p>
      )}
    </div>
  );
}

export { CostProfile };
